module.exports = __webpack_public_path__ + "img/p2.f22359c2.png";